import AppRoute from "models/AppRoute"

const LiebherrMachineArticlesRoute = new AppRoute({
    route: "/app-settings/liebherr-machine-articles",
    navbar: true,
    authRequired: true,
})

export default LiebherrMachineArticlesRoute
